import {Dialog} from "@components/interface/Dialog";
import {selectDialog} from "@redux/selectors/dialog";
import {connect} from "react-redux";
import {IDialog, update as updateDialog} from "@redux/slices/dialog";
import {Update} from "@redux/slices/base";
import {Definition} from "./definition/Definition";
import {Vector2} from "@utility/vector2";

interface IDefinitionDialog {
    dialog: IDialog
    onNavigate: (pos: Vector2) => void
    updateDialog: Update
}
function DefinitionDialog({dialog, onNavigate, updateDialog}: IDefinitionDialog) {
    if (dialog.name !== "definition") return null;
    const position = dialog.data.position ? new Vector2(dialog.data.position) : undefined;
    const handleVisit = position ? () => {
        onNavigate(position);
        updateDialog({update: {name: ""}});
    } : undefined;
    return (
        <Dialog close={true}>
            <Definition onVisit={handleVisit} word={dialog.data.word}/>
        </Dialog>
    )
}
const mapStateToProps = (store: never) => ({
    dialog: selectDialog(store)
});
const connected = connect(mapStateToProps, {
    updateDialog
})(DefinitionDialog);
export {connected as DefinitionDialog}
